<div class="achievement-details">
    @if (achievementResource.isLoading()) {
        Loading...
    } @else if (achievementResource.error()) {
        <div>Oh no, we couldn't fetch that achievement!</div>
    } @else {
        @let achievement = achievementResource.value();
        @if (achievement) {
            <div class="achievement-overlay">
                <p class="achievement-description">{{ achievement.Description }}</p>
            </div>
            <img class="achievement-img" [src]="achievement.ImagePath" alt="{{ achievement.Name }}" />
            <p class="achievement-name">
                <strong>{{ achievement.Name }}</strong>
            </p>
        } @else {
            <div>Oh no, we couldn't fetch that achievement!</div>
        }
    }
</div>
